import { Button } from 'primereact/button';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import React, { useEffect, useState } from 'react';
import { ButtonGroup, Card, Container, ToggleButton } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router';
import { ApiDelete, ApiGet } from '../../helper/API/ApiData';
import { Column, ColumnFilterElementTemplateOptions } from 'primereact/column';
import swal from 'sweetalert';
import { useDispatch, useSelector } from 'react-redux';
import { setShgTrainingView } from '../../redux/actions/shgTrainingActions';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from "@fullcalendar/interaction"
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css'; // needs additional webpack config!
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { timestampBodyTemplate } from '../../utils/helper';
import TrainingDashboard from '../Dashboard/TrainingDashboard';
// import { Tooltip } from '@mui/material';

type SHG = {
    id: string
    name: string
}
const ShgTraining = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const dt = React.useRef<DataTable<any>>(null)

    const { id } = useParams()

    const shgTrainingView = useSelector((store: any) => store.shgTraining.shgTrainingView)

    const [shgTrainings, setShgTrainings] = useState([])
    const [events, setEvents] = useState([])

    const [shgs, setShgs] = useState<SHG[]>([])
    const [selectedShg, setSelectedShg] = useState([])
    const [filters, setFilters] = useState({
        shg: { value: null, matchMode: FilterMatchMode.IN },
    });

    const handleCreate = () => {
        navigate(`add`)
    }

    useEffect(() => {
        ApiGet(`training`)
            .then((res: any) => {
                if (res && res.status === 200) {
                    if (res && res.data) {
                        setShgTrainings(res.data)
                        // parse the data into events
                        const uniqueShgs: SHG[] = []
                        const eventList = res.data.map((shgTraining: any) => {
                            if (!uniqueShgs.some(shg => shg.id === shgTraining.shg.id)) {
                                uniqueShgs.push(shgTraining.shg)
                            }
                            return {
                                ...shgTraining,
                                title: shgTraining.name_of_trainer,
                                start: shgTraining.start_timestamp,
                                end: shgTraining.end_timestamp,
                                editable: false,
                                interactive: true,
                            }
                        })
                        setEvents(eventList)
                        setShgs(uniqueShgs)
                    }
                }
            })
    }, [])

    const handleUpdate = (memberId: string): void => {
        navigate(`add/?id=${memberId}`)
    }

    const handleDelete = (shgTrainingId: string): void => {
        swal({
            title: "Are you sure?",
            text: "you want to delete this SHG Training?",
            icon: "error",
            buttons: ["cancel", "ok"],
            dangerMode: true,
        }).then((result) => {
            if (result) {
                ApiDelete(`shg/${id}/trainings/${shgTrainingId}`, {})
                    .then((res: any) => {
                        if (res.status === 200) {
                            toast.success("Successfully deleted the shg")
                            // Refetch the shg list
                            setShgTrainings(prevShgTrainings => prevShgTrainings.filter((shgTraining: any) => shgTraining.id !== shgTrainingId))
                            setEvents(prevEvents => prevEvents.filter((shgTraining: any) => shgTraining.id !== shgTrainingId))
                        }
                    })
                    .catch((error) => { return error })
            }
        })
    }

    const actionBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" style={{ borderRadius: "50%" }} rounded outlined className="mr-2" onClick={() => handleUpdate(rowData.id)} />
                <Button icon="pi pi-trash" style={{ borderRadius: "50%", marginLeft: "10px" }} rounded outlined severity="danger" onClick={() => handleDelete(rowData.id)} />
            </React.Fragment>
        );
    };

    const handleDateClick = (arg: any) => {

    }

    // Let this be here if needed to change the background and event style
    // const handleEventContent = (event: any) => {
    //     console.log("🚀 ~ handleEventClick ~ event:", event)
    //     console.log("🚀 ~ handleEventClick ~ event.event._def.extendedProps:", event.event._def.extendedProps)
    //     return (
    //         <>
    //             <Tooltip target=".knob" position='top' content={`asdasdasd`} />
    //             <div className='knob d-flex justify-content-between w-100'
    //                 style={{
    //                     background: '#0d6efd',
    //                     color: '#fff',
    //                     padding: '5px',
    //                     borderRadius: '5px'
    //                 }}>
    //                 <p className='knob'>{event.timeText}</p>
    //                 <i>{event.event.title}</i>

    //             </div>
    //         </>

    //     )
    // };

    const handleAccept = (shgTrainingId: string) => {
        navigate(`/shgadmin/trainings/add/?id=${shgTrainingId}`)
    }

    const handleEventClick = (info: any) => {
        const extendedProps = info.event._def.extendedProps
        confirmPopup({
            target: info.el,
            message: (
                <>
                    <p>SHG: {extendedProps.shg.name}</p>
                    <p>Name of Partner company: {extendedProps.partner_company}</p>
                    <p>Name of Trainer: {extendedProps.name_of_trainer}</p>
                    <p>Topics: {extendedProps.name_of_capacity_building_training_topics}</p>
                </>
            ),
            acceptLabel: "Update",
            rejectLabel: "Ok",

            acceptClassName: 'p-button-info',
            accept: () => {
                handleAccept(info.event.id)
            },
            reject: () => { }
        });
    }

    const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Calendar value={options.value} onChange={(e: any) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
    };

    const shgItemTemplate = (option: any) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const shgBodyTemplate = (rowData: any) => {
        const representative = rowData.shg;

        return (
            <div className="flex align-items-center gap-2">
                <span>{representative.name}</span>
            </div>
        );
    };

    const shgRowFilterTemplate = (options: any) => {
        return (
            <MultiSelect
                value={options.value}
                options={shgs}
                itemTemplate={shgItemTemplate}
                onChange={(e) => options.filterApplyCallback(e.value)}
                optionLabel="name"
                placeholder="Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
            />
        );
    };

    const onShgFilterChange = (value: any) => {
        let _filters = { ...filters };
        _filters['shg'].value = value;
        setFilters(_filters);
        setSelectedShg(value)
    }

    const header = (
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <span className="text-xxl text-900 font-bold">SHG Trainings List</span>
            <MultiSelect
                value={selectedShg}
                options={shgs}
                itemTemplate={shgItemTemplate}
                onChange={(e) => onShgFilterChange(e.value)}
                optionLabel="name"
                placeholder="SHGs"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
            />
            {/* <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" /> */}

        </div>
    );

    const exportCSV = (selectionOnly: boolean) => {
        dt.current?.exportCSV({ selectionOnly });
    };

    return (
        <Container fluid>

            {<TrainingDashboard showChart={false} />}

            <div className='d-flex justify-content-between m-3'>
                <div>
                    <ButtonGroup>
                        {[{ name: 'Calendar', value: 'calendar' }, { name: 'List', value: 'list' }].map((radio, idx) => (
                            <ToggleButton
                                key={idx}
                                id={`radio-${idx}`}
                                type="radio"
                                variant={'outline-success'}
                                name="radio"
                                value={radio.value}
                                checked={shgTrainingView === radio.value}
                                onChange={(e) => dispatch(setShgTrainingView(e.currentTarget.value))}
                            >
                                {radio.name}
                            </ToggleButton>
                        ))}
                    </ButtonGroup>
                </div>
                <Button icon="pi pi-plus" style={{ borderRadius: "50%" }} rounded outlined className="mr-2" onClick={handleCreate} />
            </div>

            <Card>
                {shgTrainingView === 'list' ?
                    <DataTable
                        paginator rows={10}
                        ref={dt}
                        dataKey="id"
                        value={shgTrainings}
                        header={header}
                        filters={filters}
                        footer={
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button
                                    label="Export" onClick={() => exportCSV(false)} className="w-8rem" />
                            </div>
                        }
                    // filterDisplay="row"
                    >
                        <Column
                            header="SHG Name"
                            field="shg.name"
                            // filterField="shg.name"
                            showFilterMenu={false}
                            // filterMenuStyle={{ width: '14rem' }}
                            style={{ minWidth: '14rem' }}
                        // filter
                        // filterHeaderStyle={{ minWidth: '14rem' }}
                        // body={shgBodyTemplate}
                        // filterElement={shgRowFilterTemplate}
                        ></Column>
                        <Column sortable={true} dataType='datetime'
                            body={(rowData) => <p>{timestampBodyTemplate(rowData, "start_timestamp")}</p>} field="start_timestamp" header="Start"></Column>
                        <Column body={(rowData) => <p>{timestampBodyTemplate(rowData, "end_timestamp")}</p>} field="end_timestamp" header="End"></Column>
                        <Column field="name_of_trainer" header="Name Of Trainer"></Column>
                        <Column field="name_of_capacity_building_training_topics" header="Topics"></Column>
                        <Column field="partner_company" header="Partner Company"></Column>
                        <Column body={actionBodyTemplate} style={{ minWidth: '12rem' }} bodyStyle={{ textAlign: 'center' }}></Column>

                    </DataTable>
                    :
                    <div className=''>
                        <ConfirmPopup />
                        <FullCalendar
                            eventOverlap={false}
                            plugins={[bootstrap5Plugin, dayGridPlugin, timeGridPlugin, interactionPlugin]}
                            initialView={"dayGridMonth"}
                            dateClick={handleDateClick}
                            dayMaxEvents={4}
                            events={events}
                            headerToolbar={{
                                start: "today prev,next",
                                center: "title",
                                end: "dayGridMonth,timeGridWeek,timeGridDay",
                            }}
                            themeSystem='bootstrap5'
                            height="auto"
                            displayEventEnd={true}
                            eventClick={handleEventClick}
                        // eventContent={handleEventContent}
                        />

                    </div>
                }
            </Card>
        </Container>
    );
};

export default ShgTraining;